import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { shocksApi } from '../api/phase12Client';

export function ShockBanner({ refreshKey }: { refreshKey?: number }) {
  const [b, setB] = useState<any>(null);
  useEffect(() => { shocksApi.banner().then(setB).catch(() => setB(null)); }, [refreshKey]);
  if (!b || (b.level === 'none' && !b.tailwinds)) return null;
  if (b.level === 'none') return <div className="shock-banner tailwind"><div className="shock-head"><strong>Tailwind</strong><span className="small"> · {b.tailwinds}</span><Link to="/shocks" className="btn-link" style={{ marginLeft: 'auto' }}>Shock monitor →</Link></div></div>;
  const cls = b.level === 'severe' ? 'shock-banner severe' : b.level === 'shock' ? 'shock-banner shock' : 'shock-banner watch';
  return (
    <div className={cls}>
      <div className="shock-head">
        <strong>{b.level === 'watch' ? '⚠ External shock watch' : '⚠ ECONOMY UNDER EXTERNAL SHOCK'}</strong>
        <span className="small"> · max scale {b.max_scale.toFixed(0)}/5 · growth impact {b.total_impact_gdp_pp >= 0 ? '+' : ''}{b.total_impact_gdp_pp.toFixed(2)} pp · inflation {b.total_impact_inflation_pp >= 0 ? '+' : ''}{b.total_impact_inflation_pp.toFixed(2)} pp · scanned {b.last_scanned_at ? b.last_scanned_at.slice(0, 16).replace('T', ' ') : 'never'}</span>
        <Link to="/shocks" className="btn-link" style={{ marginLeft: 'auto' }}>Shock monitor →</Link>
      </div>
      <div className="shock-chips">
        {b.top.map((s: any) => (
          <span key={s.id} className={`shock-chip s${Math.round(s.scale)}`} title={s.detail || ''}>
            {s.name.split(' (')[0]} · scale <strong>{s.scale.toFixed(0)}/5</strong> · β {s.beta_gdp >= 0 ? '+' : ''}{s.beta_gdp} · impact {s.impact_gdp_pp >= 0 ? '+' : ''}{s.impact_gdp_pp.toFixed(2)} pp
          </span>
        ))}
      </div>
      {b.tailwinds && <div className="small" style={{ marginTop: 4 }}>Tailwinds: {b.tailwinds}</div>}
    </div>
  );
}
